import './highlight-text.scss';

/**
 * version    1.0
 * class      <type> (Highlight Text)
 */
export class HighlightText {}
